import { CustomEmpty } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { SelectedMaterialItem as ISelectedMaterialItem } from 'pages/material/models';
import React from 'react';

import type { MaterialToEditAmount } from '../EditAmountForm';
import SelectedMaterialItem from '../SelectedMaterialItem';

interface Props {
  items: ISelectedMaterialItem[];
  onDelete: (materialId: string) => void;
  onEdit: (item: MaterialToEditAmount) => void;
}

const MaterialToMoveList: React.FC<Props> = (props): React.ReactElement => {
  const { items, onDelete, onEdit } = props;

  const { t } = useCustomTranslation();

  return (
    <div className="SelectedMaterialList">
      <div className="SelectedMaterialList_head">{t('stores.materialToMove')}</div>
      <div className="SelectedMaterialList_content">
        {items.length < 1 ? (
          <CustomEmpty description={t('stores.noIncomeMaterialSelected')} />
        ) : (
          <div className="SelectedMaterialList_items">
            {items.map((item) => (
              <SelectedMaterialItem
                key={item.materialId}
                item={item}
                onEdit={() =>
                  onEdit({
                    materialId: item.materialId,
                    amount: item.amount,
                    maxAmount: item.maxAmount
                  })
                }
                onDelete={() => onDelete(item.materialId)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MaterialToMoveList;
